export default __webpack_public_path__ + "static/media/mail-pencil.526fdbe7.svg";